export function animationsBg() {
    let AnimationParent = $(".animation-bg, .header-section-decor");

    AnimationParent.each(function () {
        let $animationHolder = this.querySelector(".animation-holder");
        let $animationHolderPath = $animationHolder.dataset.animation;
        let animationData = {
            container: $animationHolder,
            renderer: "svg",
            path: $animationHolderPath
        };
        let animation = bodymovin.loadAnimation(animationData);
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/animationsBg.js